import { useState } from 'react';
import TopBar from '@/components/TopBar';
import Projects from '@/pages/Projects';
import TopicDetail from '@/pages/TopicDetail';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ProjectPhase } from '@/constants';
import { useOpointUser } from '@opoint/authjs-react';

const queryClient = new QueryClient();

const ProjectsOverview: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState<ProjectPhase>(
    ProjectPhase.DOING
  );

  const user = useOpointUser();

  return (
    <div>
      {user?.is_staff ? (
        <QueryClientProvider client={queryClient}>
          <Router>
            <div className='app-container'>
              <div className='topbar'>
                <TopBar
                  selectedTab={selectedTab}
                  setSelectedTab={setSelectedTab}
                />
              </div>
              <div className='content'>
                <Routes>
                  <Route
                    path='/'
                    element={<Projects selectedTab={selectedTab} />}
                  />
                  <Route path='/projects/:topicId' element={<TopicDetail />} />
                </Routes>
              </div>
            </div>
          </Router>
        </QueryClientProvider>
      ) : (
        <div>Access denied</div>
      )}
    </div>
  );
};

export default ProjectsOverview;
